module.exports = __webpack_public_path__ + "static/media/diamonds-jack.35fe6d0c.png";